import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { mapState } from 'vuex';
import { themesMixin } from '../../../utils/themes';
import formMixin from '../formMixin';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicApplicationsDetails',
  components: {
    MarkdownItVueLight
  },
  mixins: [formMixin, themesMixin],
  props: {
    applicationObj: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      exportDialog: false,
      application: {},
      reportingMetics: {},
      packets: [],
      reportingPeriods: [{
        text: this.$i18n_t('NiotaClassic.Applications.details.oneDay'),
        value: '1d'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneWeek'),
        value: '1w'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.fourWeeks'),
        value: '4w'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneYear'),
        value: '48w'
      }],
      metricsSignal: {},
      selectedPeriod: {
        text: this.$i18n_t('NiotaClassic.Applications.details.oneDay'),
        value: '1d'
      },
      reportingPeriodIndex: 0,
      isLoading: true,
      isLoadingMetrics: true,
      isLoadingHistoryMetrics: true,
      isLoadingCustomDevices: true,
      isLoadingDevicesBattery: true,
      isLoadingReportingMetics: true,
      isLoadingNotNominal: false,
      isLoadingSetDevicesBattery: false,
      isLoadingUnsetDevicesBattery: false,
      overviewPie: {},
      nominalDevicesPie: {},
      snrGraph: {},
      spreadingFactorGraph: {},
      dailyPacketsgraph: {},
      dailyPacketsgraphOptions: {},
      hourlyPacketsgraph: {},
      hourlyPacketsgraphOptions: {},
      customDevices: {},
      customDevicesResponse: {},
      spreadingFactorGraphOptions: {
        legend: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 7,
              max: 12,
              stepSize: 0.5
            }
          }]
        }
      },
      spreadingFactorAverage: 0,
      snrFullData: [],
      statistics: {},
      devicesBatteryGroups: {},
      devicesBatteryGroupsCount: {},
      devicesBatteryResponse: {},
      maxCardDevices: 50,
      notNominalDevicesList: [],
      setBatteryDevices: [],
      unsetBatteryDevices: [],
      websocketPackets: [],
      wsConnected: false,
      deviceFormDialog: false,
      deviceTypes: [],
      applications: [],
      editedDevice: null,
      hideMapTrigger: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions', 'colorHexLight', 'colorHexDark'])
  },
  watch: {
    applicationObj: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.teardownWebSocket();
      this.setupN1WebSocket(this.applicationObj.id, get(this.applicationObj, 'account.data.realTimeApiKey'));
      this.getReportingMetrics(this.applicationObj.id, {
        range: this.selectedPeriod.value
      });
      this.getSignalMetrics(this.applicationObj.id);
      this.getFullMetrics(this.applicationObj.id);
      this.getCustomDevices(this.applicationObj.id);
      this.getDevicesBatteryStatus(this.applicationObj.id);
    }, 500),
    color: debounce(function () {
      set(this.overviewPie, 'color', this.vuetifyColorHex());
      set(this.nominalDevicesPie, 'color', this.vuetifyColorHex());
      set(this.hourlyPacketsgraph, 'individual[0].color', this.vuetifyColorHex());
      set(this.dailyPacketsgraph, 'individual[0].color', this.vuetifyColorHex());
      set(this.snrGraph, 'common.color', this.vuetifyColorHex());
      set(this.spreadingFactorGraph, 'color', this.vuetifyColorHex());
      this.updateDailyPacketsgraph();
      this.updateHourlyPacketsgraph();
    }, 500)
  },
  mounted() {
    // this.getReportingMetrics(this.applicationObj.id, { range: '1d' });
  },
  destroyed() {
    this.teardownWebSocket();
  },
  created() {
    this.application = cloneDeep(this.applicationObj);
  },
  methods: {
    getDeviceStatus(device) {
      const isNoOperationalStatusDeviceId = this.customDevicesResponse.noOperationalStatusDeviceIds.includes(device.id);
      const opStatusText = get(device, 'properties.operational_status.text');
      if (isNoOperationalStatusDeviceId || !opStatusText) {
        return this.$i18n_t('NiotaClassic.Applications.details.noStatus');
      }
      return `STATUS: ${opStatusText}`;
    },
    openLink() {
      window.open(this.applicationObj.url);
    },
    getReportingMetrics(id, reportingData) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      this.isLoadingReportingMetics = true;
      return NiotaClassicApiService.getApplicationMetricsReporting(id, reportingData).then(res => {
        this.reportingMetics = res.data;
        this.notNominalDevicesList = this.reportingMetics.notNominalDevices;
        this.updateOverviewPie();
        this.updateNominalDevicesPie();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetching = false;
        this.isLoadingReportingMetics = false;
      });
    },
    setReportingPeriod(periodIndex) {
      this.ReportingPeriod = periodIndex;
      this.selectedPeriod = this.reportingPeriods[periodIndex];
      this.getReportingMetrics(this.applicationObj.id, {
        range: this.selectedPeriod.value
      });
    },
    updateOverviewPie() {
      const onlineDevicesPercent = this.reportingMetics.devicesOnlineInPercent;
      const offlineDevicesPercent = this.reportingMetics.devicesOfflineInPercent;
      const onlineDevices = this.reportingMetics.devicesOnlineCount;
      const offlineDevices = this.reportingMetics.devicesOfflineCount;
      this.overviewPie = {
        data: [onlineDevices, offlineDevices],
        color: this.vuetifyColorHex(),
        labels: [`Online (${onlineDevicesPercent}%)`, `Offline (${offlineDevicesPercent}%)`]
      };
    },
    updateNominalDevicesPie() {
      const nomPercent = this.reportingMetics.nominalInPercent;
      const notNomDPercent = this.reportingMetics.notNominalInPercent;
      const nominalPercent = this.reportingMetics.nominalDevicesCount;
      const notNominalDPercent = this.reportingMetics.notNominalDevicesCount;
      this.nominalDevicesPie = {
        data: [nominalPercent, notNominalDPercent],
        color: this.vuetifyColorHex(),
        labels: [`Nominal (${nomPercent}%)`, `Non-Nominal (${notNomDPercent}%)`]
      };
    },
    getSignalMetrics(id) {
      if (this.isFetchingMetrics) {
        return;
      }
      this.isFetchingMetrics = true;
      this.isLoadingMetrics = true;
      return NiotaClassicApiService.getApplicationMetricsSignal(id).then(res => {
        this.metricsSignal = res.data;
        this.snrFullData = this.metricsSignal.snr;
        // this.updateSNRgraph();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetchingMetrics = false;
        this.isLoadingMetrics = false;
      });
    },
    getFullMetrics(id) {
      if (this.isFetchingHistoryMetrics) {
        return;
      }
      this.isFetchingHistoryMetrics = true;
      this.isLoadingHistoryMetrics = true;
      return NiotaClassicApiService.getApplicationMetricsHistory(id).then(res => {
        this.fullMetrics = res.metrics;
        this.statistics = res.metrics.statistics || {
          invalid: true
        };
        // this.snrFullData = this.metricsSignal.snr;
        this.updateSNRgraph();
        this.updateDailyPacketsgraph();
        this.updateHourlyPacketsgraph();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetchingHistoryMetrics = false;
        this.isLoadingHistoryMetrics = false;
      });
    },
    updateSNRgraph() {
      if ((get(this.fullMetrics, 'signal.snr') || []).length === 0) {
        return;
      }
      let labels = this.fullMetrics.signal.snr.map(k => {
        let date = new Date(k.time);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        return `${day}.${month}`;
      });
      const snrData = this.fullMetrics.signal.snr.map(k => {
        return k.value;
      });
      const rssiData = this.fullMetrics.signal.rssi.map(k => {
        return k.value;
      });
      const spreadingFactorData = this.fullMetrics.signal.spreading_factor.data.map(k => {
        return k.value;
      });
      this.spreadingFactorAverage = this.fullMetrics.signal.spreading_factor.average;
      this.spreadingFactorGraph = {
        data: spreadingFactorData,
        label: 'SF',
        color: this.vuetifyColorHex(),
        dataLabels: labels
      };
      this.snrGraph = {
        common: {
          color: this.vuetifyColorHex(),
          labels: labels
        },
        individual: [{
          data: snrData,
          label: 'SNR'
        }, {
          data: rssiData,
          label: 'RSSI'
        }]
      };
    },
    updateDailyPacketsgraph() {
      if ((get(this.fullMetrics, 'daily') || []).length === 0) {
        this.dailyPacketsgraph = {
          common: {
            color: false,
            labels: []
          },
          individual: [{
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.latest'),
            color: this.vuetifyColorHex()
          }, {
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.previous'),
            color: '#c2c2c2'
          }]
        };
        return;
      }
      let labels = this.fullMetrics.daily.map(k => {
        let date = new Date(k.date);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        return `${day}.${month}`;
      });
      const dailyData = this.fullMetrics.daily.map(k => {
        return k.value;
      });
      const previousDailyData = this.fullMetrics.daily_previous_Period.map(k => {
        return k.value;
      });
      this.dailyPacketsgraph = {
        common: {
          color: false,
          labels: labels
        },
        individual: [{
          data: dailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.latest'),
          color: this.vuetifyColorHex()
        }, {
          data: previousDailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.previous'),
          color: '#c2c2c2'
        }]
      };
      // To only show the main chart and not show the packets from yesterday
      if (!this.showOrHideDetails('statistics')) {
        this.dailyPacketsgraph = get(this.dailyPacketsgraph, 'individual[0]');
        set(this.dailyPacketsgraph, 'dataLabels', labels);
      }
      if (!this.statistics.invalid) {
        this.dailyPacketsgraphOptions.max = this.statistics.custom_period_previous.max > this.statistics.custom_period.max ? this.statistics.custom_period_previous.max : this.statistics.custom_period.max;
        this.dailyPacketsgraphOptions.annotations = [];
        if (this.statistics.custom_period.average) {
          this.dailyPacketsgraphOptions.annotations.push({
            value: this.statistics.custom_period.average,
            label: `${this.$i18n_t('NiotaClassic.Applications.details.Average')} (${this.statistics.custom_period.average.toFixed(2)}/d)`,
            labelPadding: -150
          });
        }
        if (this.statistics.custom_period_previous.average) {
          this.dailyPacketsgraphOptions.annotations.push({
            value: this.statistics.custom_period_previous.average,
            label: `${this.$i18n_t('NiotaClassic.Applications.details.PreviousAverage')} (${this.statistics.custom_period_previous.average.toFixed(2)}/d)`,
            labelPadding: 150
          });
        }
      }
    },
    updateHourlyPacketsgraph() {
      if ((get(this.fullMetrics, 'hourly') || []).length === 0) {
        this.hourlyPacketsgraph = {
          common: {
            color: false,
            labels: []
          },
          individual: [{
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.receivedLast24Hour'),
            color: this.vuetifyColorHex()
          }, {
            data: [],
            label: this.$i18n_t('NiotaClassic.Applications.details.fromYesterday'),
            color: '#c2c2c2'
          }]
        };
        return;
      }
      let labels = this.fullMetrics.hourly.map(k => {
        k.date = new Date(k.date);
        let hours = `0${k.date.getHours()}`.slice(-2);
        return `${hours}:00`;
      });
      const dailyData = this.fullMetrics.hourly.map(k => {
        return k.value;
      });
      const previousDailyData = this.fullMetrics.hourly_yesterday.map(k => {
        return k.value;
      });
      this.hourlyPacketsgraph = {
        common: {
          color: false,
          labels: labels
        },
        individual: [{
          data: dailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.receivedLast24Hour'),
          color: this.vuetifyColorHex()
        }, {
          data: previousDailyData,
          label: this.$i18n_t('NiotaClassic.Applications.details.fromYesterday'),
          color: '#c2c2c2'
        }]
      };
      if (!this.statistics.invalid) {
        this.hourlyPacketsgraphOptions.max = this.statistics.daily_yesterday.max > this.statistics.daily.max ? this.statistics.daily_yesterday.max : this.statistics.daily.max;
        this.hourlyPacketsgraphOptions.annotations = [];
        if (this.statistics.daily.average) {
          this.hourlyPacketsgraphOptions.annotations.push({
            value: this.statistics.daily.average,
            label: `${this.$i18n_t('NiotaClassic.Applications.details.Average24hr')} (${this.statistics.daily.average.toFixed(2)}/d)`,
            labelPadding: -150
          });
        }
        if (this.statistics.daily_yesterday.average) {
          this.hourlyPacketsgraphOptions.annotations.push({
            value: this.statistics.daily_yesterday.average,
            label: `${this.$i18n_t('NiotaClassic.Applications.details.AverageYesterday')} (${this.statistics.daily_yesterday.average.toFixed(2)}/d)`,
            labelPadding: 150
          });
        }
      }
      // To only show the main chart and not show the packets from yesterday
      if (!this.showOrHideDetails('statistics')) {
        this.hourlyPacketsgraph = get(this.hourlyPacketsgraph, 'individual[0]');
        set(this.hourlyPacketsgraph, 'dataLabels', labels);
      }
    },
    getCustomDevices(id) {
      if (this.isFetchingCustomDevices) {
        return;
      }
      this.isFetchingCustomDevices = true;
      this.isLoadingCustomDevices = true;
      return NiotaClassicApiService.getApplicationCustomDevices(id).then(res => {
        this.customDevicesResponse = res.data;
        this.customDevices = res.data.devices;
        this.setCustomDevicesColor();
        // this.snrFullData = this.metricsSignal.snr;
        // this.updateSNRgraph();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetchingCustomDevices = false;
        this.isLoadingCustomDevices = false;
      });
    },
    filterDevices(group, deviceIds = false) {
      switch (group) {
        case 'notNominal':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingNotNominal = true;
              return NiotaClassicApiService.getApplicationFilteredDevices(this.applicationObj.id, {
                deviceIds
              }).then(res => {
                this.notNominalDevicesList = res.data.devices;
              }).catch(error => {
                console.error('Error:', error);
              }).finally(() => {
                this.isLoadingNotNominal = false;
              });
            } else {
              this.notNominalDevicesList = [];
            }
          } else {
            this.notNominalDevicesList = this.reportingMetics.notNominalDevices;
          }
          break;
        case 'operational':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingCustomDevices = true;
              return NiotaClassicApiService.getApplicationFilteredDevices(this.applicationObj.id, {
                deviceIds
              }).then(res => {
                this.customDevices = res.data.devices;
                this.setCustomDevicesColor();
              }).catch(error => {
                console.error('Error:', error);
              }).finally(() => {
                this.isLoadingCustomDevices = false;
              });
            } else {
              this.customDevices = [];
            }
          } else {
            this.customDevices = this.customDevicesResponse.devices;
          }
          break;
        case 'unsetBattery':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingUnsetDevicesBattery = true;
              return NiotaClassicApiService.getBatteryLevelFilteredDevices(this.applicationObj.id, {
                deviceIds
              }).then(res => {
                this.unsetBatteryDevices = res.unsetDevices;
                this.setunsetDevicesColor();
              }).catch(error => {
                console.error('Error:', error);
              }).finally(() => {
                this.isLoadingUnsetDevicesBattery = false;
              });
            } else {
              this.unsetBatteryDevices = [];
            }
          } else {
            this.unsetBatteryDevices = this.devicesBatteryGroups.unsetDevices;
          }
          break;
        case 'setBattery':
          if (deviceIds) {
            if (deviceIds.length) {
              this.isLoadingSetDevicesBattery = true;
              return NiotaClassicApiService.getBatteryLevelFilteredDevices(this.applicationObj.id, {
                deviceIds
              }).then(res => {
                this.setBatteryDevices = res.allBatteryAlerts;
                this.setDevicesBatteryLvlColor();
              }).catch(error => {
                console.error('Error:', error);
              }).finally(() => {
                this.isLoadingSetDevicesBattery = false;
              });
            } else {
              this.setBatteryDevices = [];
            }
          } else {
            this.setBatteryDevices = this.devicesBatteryResponse.allBatteryAlerts;
          }
      }
    },
    filterCustomDevices(statusType = 'any') {
      switch (statusType) {
        case 'operational':
          return this.customDevices.filter(device => {
            this.customDevicesResponse.inOperationDeviceIds.includes(device.id);
          });
        case 'nonOperational':
          return this.customDevices.filter(device => {
            this.customDevicesResponse.notOperationalDeviceIds.includes(device.id);
          });
        case 'noStatus':
          return this.customDevices.filter(device => {
            this.customDevicesResponse.noOperationalStatusDeviceIds.includes(device.id);
          });
        default:
          return this.customDevices;
      }
    },
    setCustomDevicesColor() {
      this.customDevicesResponse.inOperationDeviceIds.forEach(deviceId => {
        this.customDevices.filter(customDevice => customDevice.id === deviceId).forEach(device => device.textColor = 'green');
      });
      this.customDevicesResponse.notOperationalDeviceIds.forEach(deviceId => {
        this.customDevices.filter(customDevice => customDevice.id === deviceId).forEach(device => device.textColor = 'red');
      });
      this.customDevicesResponse.noOperationalStatusDeviceIds.forEach(deviceId => {
        this.customDevices.filter(customDevice => customDevice.id === deviceId).forEach(device => device.textColor = 'orange');
      });
    },
    setunsetDevicesColor() {
      this.devicesBatteryResponse.withoutTypeDeviceIds.forEach(deviceId => {
        this.unsetBatteryDevices.filter(device => device.id === deviceId).forEach(device => device.textColor = 'red');
      });
      this.devicesBatteryResponse.withoutLevelDeviceIds.forEach(deviceId => {
        this.unsetBatteryDevices.filter(device => device.id === deviceId).forEach(device => device.textColor = 'orange');
      });
    },
    setDevicesBatteryLvlColor() {
      this.devicesBatteryResponse.alertDeviceIds.forEach(deviceId => {
        this.setBatteryDevices.filter(device => device.id === deviceId).forEach(device => device.textColor = 'red');
      });
      this.devicesBatteryResponse.warningDeviceIds.forEach(deviceId => {
        this.setBatteryDevices.filter(device => device.id === deviceId).forEach(device => device.textColor = 'orange');
      });
    },
    getDevicesBatteryStatus(id) {
      if (this.isFetchingDevicesBattery) {
        return;
      }
      this.isFetchingDevicesBattery = true;
      this.isLoadingDevicesBattery = true;
      return NiotaClassicApiService.getApplicationDevicesBatteryStatus(id).then(res => {
        this.devicesBatteryResponse = res;
        this.devicesBatteryGroups = res.devices_groups;
        this.unsetBatteryDevices = this.devicesBatteryGroups.unsetDevices;
        this.setBatteryDevices = this.devicesBatteryResponse.allBatteryAlerts;
        this.devicesBatteryGroupsCount = res.devices_groups_count;
        this.devicesBatteryStatus = res.devices;
        this.setunsetDevicesColor();
        this.setDevicesBatteryLvlColor();
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        this.isFetchingDevicesBattery = false;
        this.isLoadingDevicesBattery = false;
      });
    },
    filterDevicesBattery(statusType = 'any') {
      switch (statusType) {
        case 'unset':
          return this.devicesBatteryStatus.filter(device => {
            this.devicesBatteryResponse.withoutTypeDeviceIds.includes(device.id);
          });
        case 'withoutDeviceType':
          return this.devicesBatteryStatus.filter(device => {
            this.devicesBatteryResponse.withoutTypeDeviceIds.includes(device.id);
          });
        case 'withoutBatteryLevel':
          return this.devicesBatteryStatus.filter(device => {
            this.devicesBatteryResponse.withoutLevelDeviceIds.includes(device.id);
          });
        case 'warning':
          return this.devicesBatteryStatus.filter(device => {
            this.devicesBatteryResponse.warningDeviceIds.includes(device.id);
          });
        case 'alert':
          return this.devicesBatteryStatus.filter(device => {
            this.devicesBatteryResponse.alertDeviceIds.includes(device.id);
          });
        default:
          return this.customDevices;
      }
    },
    setupN1WebSocket(id, key) {
      if (key) {
        this.lclObjectStr = 'Establishing connection\n';
        this.connection = new WebSocket(`ws${this.n1Protocol === 'https' ? 's' : ''}://${this.n1Host}/api/x/websocket/applications/${id}?auth=${key}`);
        const instance = this;
        this.connection.onmessage = function (event) {
          instance.lclObjectStr += `Data-Packet START:\n${event.data}\nData-Packet END\n`;
          // console.log('WS-Data:', { data: event.data });
          instance.websocketPackets.unshift(JSON.parse(event.data));
        };
        this.connection.onopen = function () {
          // console.log('WS: Connected');
          instance.lclObjectStr += 'Successfully connected to the websocket server\nWaiting for data...\n';
          instance.wsConnected = true;
        };
        this.connection.onerror = function (error) {
          instance.lclObjectStr += `An error occurred: ${error}\n`;
        };
        this.connection.onclose = function () {
          instance.lclObjectStr += 'Disconnected from WebSocket Server\n';
        };
      } else {
        console.error('WS: No API key for this application');
      }
    },
    teardownWebSocket() {
      if (this.connection) {
        this.connection.close();
      }
    },
    viewDevice(deviceId) {
      this.$router.push({
        path: `/niota-classic/devices/${deviceId}/details`
      });
    },
    async editDevice(deviceId) {
      if (!this.deviceTypes.length && !this.applications.length) {
        await this.deviceTypeFetchPlain();
        await this.applicationsFetchPlain();
      }
      await this.fetchDeviceDetails(deviceId);
      this.deviceFormDialog = true;
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain().then(res => {
        this.applications = res.data.applications;
      }).catch(() => {
        this.applications = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
      });
    },
    fetchDeviceDetails(deviceId) {
      NiotaClassicApiService.deviceGetDetails(deviceId).then(res => {
        this.editedDevice = res.data.device;
      }).catch(() => {
        this.editedDevice = null;
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.deviceNotFound'), 'error');
      });
    },
    showOrHideDetails(property = 'SFgraph') {
      return this.applicationObj && get(this.applicationObj, `properties.detailsViewCards.${property}`);
    },
    hideMap(hide) {
      this.hideMapTrigger = hide;
    }
  }
};